/*
*   ~ Project event keys go in here ~
*
*   Usage in components:
*
*   import Events from '@vaersaagod/tools/Events';
*   import * as eventKeys from '../lib/events';
*   Events.publish(eventKeys.SOME_EVENT, 'This ES6 shit is wack');
*
 */

export const MENU_OPEN = 'MENU_OPEN';
export const MENU_CLOSE = 'MENU_CLOSE';
export const MODAL_OPEN = 'MODAL_OPEN';
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const VIDEO_OPEN = 'VIDEO_OPEN';
export const VIDEO_CLOSE = 'VIDEO_CLOSE';
export const HOTSPOT_OPEN = 'HOTSPOT_OPEN';
export const HOTSPOT_CLOSE = 'HOTSPOT_CLOSE';
